import {
    GET_SUPPLIERS_SUCCESS,
    GET_SUPPLIERS_FAIL,
    ADD_NEW_SUPPLIER_SUCCESS,
    ADD_NEW_SUPPLIER_FAIL,
    UPDATE_SUPPLIER_SUCCESS,
    UPDATE_SUPPLIER_FAIL,
    DELETE_SUPPLIER_SUCCESS,
    DELETE_SUPPLIER_FAIL,
    GET_SUPPLIER_INVOICES_SUCCESS,
    GET_SUPPLIER_INVOICES_FAIL,
    ADD_NEW_SUPPLIER_INVOICE_SUCCESS,
    ADD_NEW_SUPPLIER_INVOICE_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    suppliers: [],
    invoices: [],
    error: {},
}

const Suppliers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_SUPPLIERS_SUCCESS:
            return {
                ...state,
                suppliers: action.payload,
            }
        case GET_SUPPLIERS_FAIL:
            return {
                ...state,
                error: action.payload,
            }
        case ADD_NEW_SUPPLIER_SUCCESS:
            return {
                ...state,
                suppliers: {
                    ...state.suppliers,
                    data: [action.payload, ...state.suppliers.data]
                }
            }
        case UPDATE_SUPPLIER_SUCCESS:
            return {
                ...state,
                suppliers: {
                    ...state.suppliers,
                    data: state.suppliers.data.map(s => s.id.toString() === action.payload.id.toString() ? action.payload : s)
                }
            }
        case DELETE_SUPPLIER_SUCCESS:
            return {
                ...state,
                suppliers: {
                    ...state.suppliers,
                    data: state.suppliers.data.filter(s => s.id.toString() !== action.payload.toString())
                }
            }
        case GET_SUPPLIER_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: action.payload,
            }
        case ADD_NEW_SUPPLIER_INVOICE_SUCCESS:
            return {
                ...state,
                invoices: {
                    ...state.invoices,
                    data: [action.payload, ...state.invoices.data]
                }
            }
        default:
            return state
    }
}

export default Suppliers
